import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/Products.css';

const features = [
  {
    title: 'Hide payment methods',
    description: 'Remove selected payment methods from checkout when they are not appropriate for a particular order or customer scenario.',
  },
  {
    title: 'Rename payment methods',
    description: 'Change payment method labels to make checkout choices clearer and more relevant to the store experience.',
  },
  {
    title: 'Reorder payment methods',
    description: 'Control the sequence in which available payment methods appear to customers at checkout.',
  },
  {
    title: 'Conditional payment rules',
    description: 'Define conditions that determine when configured payment customizations should be applied.',
  },
];

const useCases = [
  'Prioritizing preferred payment choices for relevant checkout scenarios',
  'Hiding payment options that do not suit specific order conditions',
  'Using clearer payment labels for customers',
  'Applying different payment experiences through configurable rules',
];

const ShopifyPaymentCustomization = () => {
  return (
    <main className="product-detail">
      <SEO
        title="Shopify Payment Customization App | Bularis Tech"
        description="Customize Shopify checkout payment methods by hiding, renaming, reordering, and applying conditional payment rules."
        path="/products/shopify-payment-customization"
      />
      <header className="product-hero">
        <span className="products-eyebrow">Shopify app by Bularis Tech</span>
        <h1>Shopify Payment Customization</h1>
        <p>
          Customize Shopify payment methods at checkout by hiding, renaming, reordering, and
          applying rules to the payment options presented to customers.
        </p>
      </header>

      <div className="product-content">
        <section className="product-section product-introduction">
          <div>
            <h2>More control over checkout payment options</h2>
            <p>
              Standard payment method presentation may not fit every order or customer journey.
              This Bularis Tech app gives merchants a focused way to manage how available payment
              methods are presented at Shopify checkout.
            </p>
          </div>
          <aside className="product-summary" aria-label="App summary">
            <span>Product type</span>
            <strong>Shopify app</strong>
            <span>Core purpose</span>
            <strong>Payment method customization</strong>
          </aside>
        </section>

        <section className="product-section">
          <div className="product-section-heading">
            <span className="products-eyebrow">Core capabilities</span>
            <h2>Customize payment methods with practical controls</h2>
          </div>
          <div className="product-features">
            {features.map((feature) => (
              <article className="product-feature" key={feature.title}>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="product-section">
          <h2>Typical merchant use cases</h2>
          <ul className="product-use-cases">
            {useCases.map((useCase) => <li key={useCase}>{useCase}</li>)}
          </ul>
        </section>

        <section className="product-cta">
          <div>
            <h2>Explore the app for your store</h2>
            <p>Tell us how you want to customize payment methods in your Shopify checkout.</p>
          </div>
          <Link to="/contact">Contact Bularis Tech</Link>
        </section>
      </div>
    </main>
  );
};

export default ShopifyPaymentCustomization;
